import React from 'react';
import s from './JobIcon.module.scss';

const VideoTriangleIcon = () => {
  return (
    <svg className={s.videoTriangleIcon} width="35" height="39" viewBox="0 0 35 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32.4545 15.0746C35.8485 17.0415 35.8485 21.9585 32.4545 23.9254L7.63637 38.3078C4.24243 40.2746 -1.65299e-06 37.8161 -1.48105e-06 33.8824L-2.23697e-07 5.11759C-5.17515e-08 1.18394 4.24242 -1.2746 7.63636 0.692227L32.4545 15.0746Z" fill="white"/>
    </svg>
  )
}

export default VideoTriangleIcon
